export const UNINITIALIZED_PROVIDER = "You used the hook with no provider";
export const throwUninitializedError = () => {
  throw Error(UNINITIALIZED_PROVIDER);
};
